module.exports = "images/OKOO_LOADER.e60a52b8.gif";